"use client"

import { yupResolver } from '@hookform/resolvers/yup';
import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, Snackbar, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import FieldWithLabel from '../components/FieldWithLabel';
import QuillEditor from '../components/QuillEditor';
import ImageCropper from '../components/ImageCropper';
import { removeFile, uploadFile } from '../api/file';
import { getHomeData, saveHomeData } from '../api/beranda';
import CloseIcon from "@mui/icons-material/Close";
import { getValue } from '@testing-library/user-event/dist/utils';

interface FormData {
  hero: string;
  hero_mobile: string;
  logo: string | undefined;
  hero_tagline: string;
  logo_mobile: string | undefined;
  tag_line: {
    id: string;
    en: string;
  }
  title: {
    id: string;
    en: string;
  };
  subtitle: {
    id: string;
    en: string | null;
  };
};

const validationSchema = Yup.object({
  hero: Yup.string()
    .nullable(''),
  hero_mobile: Yup.string()
    .nullable(''),
  logo: Yup.string().nullable(),
  logo_mobile: Yup.string().nullable(),
  hero_tagline: Yup.string().nullable(),
  tag_line: Yup.object().shape({
    id: Yup.string().nullable(''),
    en: Yup.string().nullable(''),
  }),
  title: Yup.object().shape({
    id: Yup.string().nullable(''),
    en: Yup.string().nullable(''),
  }),
  subtitle: Yup.object().shape({
    id: Yup.string().nullable(''),
    en: Yup.string().nullable(),
  }),
});

export default function BerandaPage() {
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({
    open: false,
    message: "",
    severity: "success",
  });

  const [isEdit, setIsEdit] = useState(false)
  const [openPrevDesk, setOpenPrevDesk] = useState(false)
  const [openPrevMobile, setOpenPrevMobile] = useState(false)
  const [openTagline, setOpenTagline] = useState(false)
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const defaultValues = {
    hero: "",
    hero_mobile: "",
    logo: "",
    logo_mobile: "",
    hero_tagline: "",
    tag_line: {
      id: "",
      en: "",
    },
    title: {
      id: "",
      en: "",
    },
    subtitle: {
      id: "",
      en: "",
    },
  }

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    control,
  } = useForm<FormData>({
    //@ts-ignore
    resolver: yupResolver(validationSchema),
    defaultValues: isEdit ? undefined : defaultValues
  });

  const handleCroppedHero = (image: string) => {
    setValue("hero", image);
  };

  const handleCroppedHeroTagline = (image: string) => {
    setValue("hero_tagline", image);
  };

  const handleCroppedHeroMobile = (image: string) => {
    setValue("hero_mobile", image);
  };

  const handleCroppedLogo = (image: string) => {
    setValue("logo", image);
  };

  const handleCroppedLogoMobile = (image: string) => {
    setValue("logo_mobile", image);
  };

  const handlePreviewDesktop = () => {
    if (!getValues('hero')) return
    setOpenPrevDesk(true)
  }

  const onCloseDesk = () => {
    setOpenPrevDesk(false)
  }

  const handlePreviewTagline = () => {
    if (!getValues('hero_tagline')) return
    setOpenTagline(true)
  }

  const onCloseTagline = () => {
    setOpenTagline(false)
  }

  const onCloseMobile = () => {
    setOpenPrevMobile(false)
  }

  const handlePreviewMobile = () => {
    if (!getValues('hero_mobile')) return
    setOpenPrevMobile(true)
  }


  const onSubmit = async (data: FormData) => {
    let uploadedPath: any = {}
    try {
      const formPayload: any = { ...data }
      const keys: string[] = Object.keys(formPayload)

      for await (const key of keys) {
        if (key.includes("hero") || key.includes("logo")) {
          //@ts-ignore
          if (typeof formPayload[key] === "string" && formPayload[key]?.startsWith("data:")) {
            try {
              const fD = new FormData();
              //@ts-ignore
              // const blob = await fetch(formPayload[key]).then((res) => res.blob());
              fD.append("file", formPayload[key]);
              const result = await uploadFile(fD);
              if (result.status) {
                const path = await result.data as string;
                console.log(path, "><><><><><>><><")
                //@ts-ignore
                uploadedPath[key] = path
              }
            } catch (error) {
              console.log(`Error upload ${key}`)
            }
          }
        }
      }

      Object.keys(uploadedPath).forEach((el: any) => {
        formPayload[el] = uploadedPath[el]
      })

      const resSave = await saveHomeData({
        ...formPayload,
      })
      if (!resSave.status) {
        setSnackbar({
          open: true,
          message: "Data beranda gagal disimpan",
          severity: "error",
        });
        return
      }

      setSnackbar({
        open: true,
        message: "Data beranda berhasil disimpan",
        severity: "success",
      });

    } catch (error) {
      console.log(error)
      const paths = Object.keys(uploadedPath)
      paths.forEach(async (k: string) => {
        //@ts-ignore
        if (uploadedPath[k]?.startsWith("http")) {
          //@ts-ignore
          await removeFile(uploadedPath[k])
        }
      })
    }
  }

  useEffect(() => {
    getHomeData().then((res: any) => {
      if (res.status) {
        console.log(res.data)
        setValue("hero", res.data?.hero)
        setValue("hero_mobile", res.data?.hero_mobile)
        setValue("logo", res.data?.logo)
        setValue("logo_mobile", res.data?.logo_mobile)
        setValue("subtitle.id", res.data?.subtitle?.id)
        setValue("subtitle.en", res.data?.subtitle?.en)
        setValue("title.id", res.data?.title?.id)
        setValue("title.en", res.data?.title?.en)
        setValue("hero_tagline", res.data?.hero_tagline)
        setValue("tag_line.id", res.data?.tag_line?.id)
        setValue("tag_line.en", res.data?.tag_line?.en)
        setIsEdit(true)
      }
    }).catch((error) => {
      console.log(error)
    })
  }, [])


  return (
    <>
      <Dialog
        open={openPrevDesk}
        onClose={onCloseDesk}
        maxWidth="lg"
        fullWidth
        keepMounted
      >
        <DialogTitle className="bg-primary-100 flex justify-between items-center">
          <span className="text-base font-semibold">
            Preview Banner Desktop
          </span>
          <div
            className="bg-white cursor-pointer border size-8 flex justify-center items-center rounded"
            onClick={onCloseDesk}
          >
            <CloseIcon />
          </div>
        </DialogTitle>
        <DialogContent className='!p-4'>
          <div
            style={{
              backgroundImage: `url(${getValues('hero')})`,
              backgroundSize: "cover", // Adjust this value as needed
              backgroundRepeat: "no-repeat",
              backgroundColor: "white",
              height: "600px", // Set a fixed height
            }}
            className="relative hidden lg:block w-full rounded-xl bg-left-bottom md:bg-left-top xl:pt-[56,25%] xl:aspect-video"
          >
            <img
              src={getValues("logo")}
              width={350}
              height={350}
              alt="hero-image"
              className="absolute -top-5 right-0 object-cover lg:object-contain size-60 lg:size-96 2xl:size-76"
            />
            <div className="absolute top-[60%] lg:top-[40%] 2xl:top-[40%] lg:text-3xl 2xl:text-4xl right-4 w-1/2 text-right">
              <h1 className="mt-16">
                <strong
                  dangerouslySetInnerHTML={{
                    __html: `${getValues("title.id") || ""}`,
                  }}
                ></strong>
              </h1>
              <div className="absolute right-0 text-xl 2xl:text-2xl text-right w-2/3 mt-2">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${getValues('subtitle.id') || ""}`,
                  }}
                  className="text-lg 2xl:text-2xl"
                ></div>
                <br />
                <span className="text-lg 2xl:text-xl text-primary-500 italic bottom-10 xl:bottom-20">
                  Pendiri Yayasan GSN
                </span>
                <br />
                <span className="text-lg 2xl:text-xl text-primary-500 italic bottom-10 xl:bottom-20">
                  Prabowo Subianto
                </span>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openPrevMobile}
        onClose={onCloseMobile}
        maxWidth="xs"
        fullWidth
        keepMounted
      >
        <DialogTitle className="bg-primary-100 flex justify-between items-center">
          <span className="text-base font-semibold">
            Preview Banner Mobile
          </span>
          <div
            className="bg-white cursor-pointer border size-8 flex justify-center items-center rounded"
            onClick={onCloseMobile}
          >
            <CloseIcon />
          </div>
        </DialogTitle>
        <DialogContent className='!p-4'>
          <div className="bg-white border relative border-gray-300 shadow-lg w-full mx-auto rounded-lg block overflow-x-hidden">
            <div className="p-6 absolute flex justify-end flex-col items-end">
              <img
                width={250}
                height={250}
                src={getValues('logo_mobile')}
                alt="Logo"
                className="size-7/12 mx-auto"
              />
              <h1 className="text-lg font-bold text-right sm:text-center sm:pl-24 w-full grow">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${getValues('title.id') || ""}`,
                  }}
                  className="text-lg font-bold text-right w-full"
                ></div>
              </h1>
              <div className="mt-2 text-xs text-gray-600 text-right">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${getValues('subtitle.id').replace(
                      'class="ql-align-right"',
                      'class="text-xs text-gray-600 px-0 text-right "'
                    )
                      .replace(
                        '<strong class="ql-size-large"',
                        '<br/><strong class="text-lg italic font-semibold ml-1 !mt-3"'
                      )
                      .replace(
                        '<span class="ql-size-large"',
                        '<span class="text-lg text-gray-600 px-0 text-right leading-5"'
                      ) || ""}`,
                  }}
                ></div>
              </div>
            </div>

            <div>
              <img
                width={350}
                height={350}
                src={
                  getValues("hero_mobile")
                }
                alt="People"
                className="w-full object-cover"
              />
            </div>

            <div className="text-center p-4">
              <p className="text-xs text-gray-500">
                Pendiri Yayasan GSN Prabowo Subianto
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openTagline}
        onClose={onCloseTagline}
        maxWidth="md"
        fullWidth
        keepMounted
      >
        <DialogTitle className="bg-primary-100 flex justify-between items-center">
          <span className="text-base font-semibold">
            Preview Tagline
          </span>
          <div
            className="bg-white cursor-pointer border size-8 flex justify-center items-center rounded"
            onClick={onCloseTagline}
          >
            <CloseIcon />
          </div>
        </DialogTitle>
        <DialogContent className='!p-4'>
          <div className="w-full relative">
            <div className="absolute bg-black/50 z-10 w-full flex justify-center items-center md:items-end md:pb-[15%] rounded-xl h-full">
              <div className="text-neutral-0 font-bold text-2xl md:text-4xl leading-normal w-full text-center">
                {/* <span className="text-5xl">
                    Bergerak dengan Hati, Berdampak untuk Negeri
                  </span>{" "}
                  <br />
                  wujudkan Indonesia Emas 2045 */}
                <div
                  className="text-white text-xl text-center"
                  dangerouslySetInnerHTML={{
                    __html: `${getValues("tag_line.id") || ""}`,
                  }}
                ></div>
              </div>
            </div>
            {getValues('hero_tagline') && (
              <img
                alt="hero-tagline"
                width={500}
                height={500}
                src={getValues('hero_tagline')}
                className={`w-full min-h-[60vh] flex justify-center rounded-xl object-cover bg-no-repeat bg-center aspect-[18/9] md:bg-[calc(28%)]`}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className="mb-8">
        <h1 className="font-bold text-3xl mb-2">Mengatur Halaman Beranda</h1>
        <p className="text-sm text-neutral-600">
          Pengaturan Banner dan Title di halaman Beranda
        </p>
      </div>
      <Box className="bg-white pt-2 pb-6 px-6 rounded items-center shadow-md gap-y-4">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="w-full flex flex-col gap-y-4 mt-4"
        >
          <FieldWithLabel label="Banner Desktop" applyMargin={true}>
            <Box className="flex flex-col gap-2">
              <ImageCropper resolution='banner' size='big' onCrop={handleCroppedHero} defaultImage={getValues("hero")} />
              {errors.hero && (
                <Typography variant="caption" color="error">
                  {errors.hero.message}
                </Typography>
              )}
            </Box>

          </FieldWithLabel>
          <FieldWithLabel label="Banner Mobile" applyMargin={true}>
            <Box className="flex flex-col gap-2">
              <ImageCropper resolution='mobile' className={"w-1/3"} onCrop={handleCroppedHeroMobile} defaultImage={getValues("hero_mobile")} />
              {errors.hero_mobile && (
                <Typography variant="caption" color="error">
                  {errors.hero_mobile.message}
                </Typography>
              )}
            </Box>
          </FieldWithLabel>
          <div className='w-1/2 flex gap-4'>
            <FieldWithLabel label="Logo Desktop" applyMargin={true}>
              <Box className="flex flex-col gap-2">
                <ImageCropper resolution='logo' size="small" onCrop={handleCroppedLogo} defaultImage={getValues("logo")} />
                {errors.logo && (
                  <Typography variant="caption" color="error">
                    {errors.logo.message}
                  </Typography>
                )}
              </Box>
            </FieldWithLabel>
            <FieldWithLabel label="Logo Mobile" applyMargin={true}>
              <Box className="flex flex-col gap-2">
                <ImageCropper resolution='logo' size="small" onCrop={handleCroppedLogoMobile} defaultImage={getValues("logo_mobile")} />
                {errors.logo_mobile && (
                  <Typography variant="caption" color="error">
                    {errors.logo_mobile.message}
                  </Typography>
                )}
              </Box>
            </FieldWithLabel>
          </div>
          <FieldWithLabel label="Judul (Bahasa Indonesia)" required>
            <TextField
              {...register("title.id")}
              error={!!errors?.title?.id}
              helperText={errors?.title?.id?.message}
            />
          </FieldWithLabel>
          <FieldWithLabel label="Subtitle (Bahasa Indonesia)" required applyMargin={true}>
            <Box>
              <QuillEditor name="subtitle.id" control={control} />
            </Box>
          </FieldWithLabel>
          <FieldWithLabel label="Judul (Bahasa Inggris)" required>
            <TextField
              {...register("title.en")}
              error={!!errors?.title?.en}
              helperText={errors?.title?.en?.message}
            />
          </FieldWithLabel>
          <FieldWithLabel label="Subtitle (Bahasa Inggris)" required applyMargin={true}>
            <Box>
              <QuillEditor name="subtitle.en" control={control} />
            </Box>
          </FieldWithLabel>
          <FieldWithLabel label="Banner Tagline" applyMargin={true}>
            <Box className="flex flex-col gap-2">
              <ImageCropper resolution='banner' onCrop={handleCroppedHeroTagline} defaultImage={getValues("hero_tagline")} />
              {errors.hero_tagline && (
                <Typography variant="caption" color="error">
                  {errors.hero_tagline.message}
                </Typography>
              )}
            </Box>
          </FieldWithLabel>
          <div className='grid grid-cols-2 gap-4'>
            <FieldWithLabel label="Tagline (Bahasa Indonesia)" required applyMargin={true}>
              <Box>
                <QuillEditor name="tag_line.id" control={control} />
              </Box>
            </FieldWithLabel>
            <FieldWithLabel label="Tagline (Bahasa Inggris)" required applyMargin={true}>
              <Box>
                <QuillEditor name="tag_line.en" control={control} />
              </Box>
            </FieldWithLabel>
          </div>
          <div className='flex items-center gap-4'>
            <Button className='max-w-sm !mt-2' onClick={handlePreviewDesktop}>
              <Typography textTransform={"capitalize"}>
                Preview Banner Dekstop
              </Typography>
            </Button>
            <Button className='max-w-sm !mt-2' onClick={handlePreviewMobile}>
              <Typography textTransform={"capitalize"}>
                Preview Banner Mobile
              </Typography>
            </Button>
            <Button className='max-w-sm !mt-2' onClick={handlePreviewTagline}>
              <Typography textTransform={"capitalize"}>
                Preview Tagline
              </Typography>
            </Button>
          </div>
          <div className="flex justify-end mt-4">
            <Button type="submit" className="!w-fit">
              <Typography textTransform={"capitalize"}>
                Simpan
              </Typography>
            </Button>
          </div>
        </form>
      </Box>
    </>
  )
}
